import {
  UserAgnosticGlobalFeatureGates,
  userAgnosticGlobalFeatureGatesDefaults,
} from '@src/server-side/api/feature-gates.types'

let userAgnosticGlobalFeatureGates: UserAgnosticGlobalFeatureGates = userAgnosticGlobalFeatureGatesDefaults

export function setUserAgnosticGlobalFeatureGatesInMemory(featureGates?: UserAgnosticGlobalFeatureGates | null) {
  if (featureGates) {
    userAgnosticGlobalFeatureGates = featureGates
  }
}

export function getUserAgnosticGlobalFeatureGatesFromMemory(): UserAgnosticGlobalFeatureGates {
  return userAgnosticGlobalFeatureGates
}
